import React, { ReactElement } from 'react';

import { IconManagerProps } from '@speeki/icons';

import {
    ButtonWrapper,
    IconWrapper,
    StyledIconManager,
} from './ButtonIconText.styled';

interface ButtonIconTextProps {
    children?: string | ReactElement;
    className?: string;
    iconProps: IconManagerProps;
    isFixed?: boolean;
    onPress: () => void;
    style?: React.CSSProperties;
    testId: string;
}

export const ButtonIconText = ({
    children,
    className,
    iconProps,
    isFixed,
    onPress,
    testId,
}: ButtonIconTextProps) => {
    return (
        <ButtonWrapper
            className={className}
            data-testid={testId}
            onClick={onPress}
        >
            {children && children}
            <IconWrapper isFixed={isFixed}>
                <StyledIconManager {...iconProps} />
            </IconWrapper>
        </ButtonWrapper>
    );
};
